export var playgroundUrls = function playgroundUrls() {
  return {
    bffUrl: 'https://bff.writing.test.cheggnet.com/graphql',
    citethisformeUrl: 'https://playground.citethisforme.com/'
  };
};
export var productionUrls = function productionUrls() {
  return {
    bffUrl: 'https://bff.writing.chegg.com/graphql',
    citethisformeUrl: 'https://www.citethisforme.com/'
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/config.js
// module id = 1248
// module chunks = 11